import { weixin } from '@tencent/vft-common';

const original = window.addEventListener;
window.addEventListener = (...args: any[]) => {
  const [eventName] = args;
  if (eventName === 'pageshow') {
    // eslint-disable-next-line no-console
    console.warn('拦截此监听', ...args);
  } else {
    // @ts-ignore
    original(...args);
  }
};

const createInterval = (maxTimes = 0) => (fn: Function, ms: number) => {
  let execCount = 0;
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (execCount >= maxTimes) {
        clearInterval(interval);
        return resolve(true);
      }
      try {
        fn();
      } catch (err) {
        clearInterval(interval);
        return reject(err);
      }
      execCount += 1;
    }, ms);
  });
};

weixin.WeixinJSBridgeReady(() => createInterval(20)(() => {
  window.WeixinJSBridge?.invoke('setFontSizeCallback', { fontSize: '2' });
}, 200));
